// import React from "react";
// import { Navigate } from "react-router-dom";
// import { to } from "react-spring";

// const ProtectedRoute = ({ children }) => {
//   try {
//     // const regex = /^[A-Za-z0-9]{28}$/;
//     const regex = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
//     const token = sessionStorage.getItem("token");
//     const user = JSON.parse(sessionStorage.getItem("adminUser"));
//     console.log(user.email);
//     // const parsedToken = JSON.parse(token);
//     // console.log(token);
//     // const uid = parsedToken.user.uid;
//     const test = regex.test(token);
//     return test ? children : <Navigate to="/admin" replace />;
//   } catch (error) {
//     console.log(error);
//     return <Navigate to="/admin" replace />;
//   }
// };

// export default ProtectedRoute;



import React from "react";
import { Navigate } from "react-router-dom";

// JWT format regex — matches a real Firebase JWT access token (3 base64 parts)
const JWT_REGEX = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

const ProtectedRoute = ({ children }) => {
  try {
    const raw = sessionStorage.getItem("token");
    if (!raw) return <Navigate to="/admin" replace />;

    // Admin.jsx stores the full Firebase UserCredential object as JSON string:
    // sessionStorage.setItem("token", JSON.stringify(res))
    // The actual JWT is nested at res.user.stsTokenManager.accessToken
    const parsed = JSON.parse(raw);

    // Try to extract the real JWT from the Firebase UserCredential
    const accessToken =
      parsed?.user?.stsTokenManager?.accessToken ||  // Firebase v9+ structure
      parsed?.user?.accessToken ||                    // alternate path
      parsed?._tokenResponse?.idToken ||             // REST API response
      (typeof parsed === "string" ? parsed : null);  // already a plain token

    if (!accessToken) return <Navigate to="/admin" replace />;

    const isValid = JWT_REGEX.test(accessToken);
    return isValid ? children : <Navigate to="/admin" replace />;

  } catch (error) {
    console.error("ProtectedRoute error:", error);
    return <Navigate to="/admin" replace />;
  }
};

export default ProtectedRoute;